export const homeIcon = (
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.6455 3.97927C13.8721 3.75274 14.1794 3.62549 14.4998 3.62549C14.8202 3.62549 15.1275 3.75274 15.3541 3.97927L22.6041 11.2293L25.0208 13.6459C25.2409 13.8738 25.3627 14.1791 25.3599 14.4959C25.3572 14.8127 25.2301 15.1158 25.006 15.3398C24.782 15.5638 24.4789 15.6909 24.1621 15.6937C23.8453 15.6964 23.5401 15.5746 23.3122 15.3545L22.9581 15.0005V22.9586C22.9581 23.5995 22.7035 24.2142 22.2503 24.6674C21.7971 25.1206 21.1824 25.3752 20.5415 25.3752H16.9165C16.596 25.3752 16.2887 25.2479 16.062 25.0213C15.8354 24.7947 15.7081 24.4874 15.7081 24.1669V20.5419H13.2915V24.1669C13.2915 24.4874 13.1642 24.7947 12.9376 25.0213C12.7109 25.2479 12.4036 25.3752 12.0831 25.3752H8.45813C7.81719 25.3752 7.20251 25.1206 6.74929 24.6674C6.29608 24.2142 6.04147 23.5995 6.04147 22.9586V15.0005L5.68742 15.3545C5.45953 15.5746 5.1543 15.6964 4.83748 15.6937C4.52066 15.6909 4.2176 15.5638 3.99356 15.3398C3.76953 15.1158 3.64245 14.8127 3.63969 14.4959C3.63694 14.1791 3.75873 13.8738 3.97884 13.6459L6.39551 11.2293L13.6455 3.97927Z"
      fill="white"
    />
  </svg>
);
export const arrowIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.25 10.5L8.75 7L5.25 3.5"
      stroke="#99A1AF"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const approveIcon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 3L4.5 8.5L2 6"
      stroke="#15803D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const rejectIcon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 3L3 9"
      stroke="#B91C1C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 3L9 9"
      stroke="#B91C1C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const downArrow = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.99988 5.99988L7.99981 9.99981L11.9997 5.99988"
      stroke="#155DFC"
      stroke-width="1.33331"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const shareIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99988 2H13.9998V5.99993"
      stroke="#99A1AF"
      stroke-width="1.33331"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.6665 9.33321L13.9997 2"
      stroke="#99A1AF"
      stroke-width="1.33331"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.9998 8.66646V12.6664C11.9998 13.02 11.8594 13.3591 11.6093 13.6092C11.3593 13.8592 11.0201 13.9997 10.6665 13.9997H3.33331C2.97969 13.9997 2.64056 13.8592 2.39052 13.6092C2.14047 13.3591 2 13.02 2 12.6664V5.33319C2 4.97957 2.14047 4.64044 2.39052 4.3904C2.64056 4.14035 2.97969 3.99988 3.33331 3.99988H7.33324"
      stroke="#99A1AF"
      stroke-width="1.33331"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const deleteIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9519_5642)">
      <path
        d="M2 3.99988H13.9998"
        stroke="#FB2C36"
        stroke-width="1.33331"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6664 3.99988V13.333C12.6664 13.9997 11.9998 14.6664 11.3331 14.6664H4.66656C3.99991 14.6664 3.33325 13.9997 3.33325 13.333V3.99988"
        stroke="#FB2C36"
        stroke-width="1.33331"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.33325 3.99987V2.66656C5.33325 1.99991 5.99991 1.33325 6.66656 1.33325H9.33318C9.99984 1.33325 10.6665 1.99991 10.6665 2.66656V3.99987"
        stroke="#FB2C36"
        stroke-width="1.33331"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.6665 7.33325V11.3332"
        stroke="#FB2C36"
        stroke-width="1.33331"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33313 7.33325V11.3332"
        stroke="#FB2C36"
        stroke-width="1.33331"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9519_5642">
        <rect width="15.9997" height="15.9997" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const editIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.9999 2H3.33331C2.97969 2 2.64056 2.14047 2.39052 2.39052C2.14047 2.64056 2 2.97969 2 3.33331V12.6665C2 13.0201 2.14047 13.3592 2.39052 13.6093C2.64056 13.8593 2.97969 13.9998 3.33331 13.9998H12.6665C13.0201 13.9998 13.3592 13.8593 13.6093 13.6093C13.8593 13.3592 13.9998 13.0201 13.9998 12.6665V7.9999"
      stroke="#4A5565"
      stroke-width="1.33331"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.2498 1.7499C12.515 1.48469 12.8747 1.33569 13.2498 1.33569C13.6248 1.33569 13.9845 1.48469 14.2497 1.7499C14.515 2.01511 14.664 2.37482 14.664 2.74988C14.664 3.12495 14.515 3.48465 14.2497 3.74987L8.24118 9.75909C8.08289 9.91726 7.88733 10.033 7.67253 10.0958L5.75723 10.6557C5.69986 10.6725 5.63905 10.6735 5.58117 10.6586C5.52328 10.6438 5.47045 10.6137 5.4282 10.5714C5.38594 10.5292 5.35583 10.4764 5.341 10.4185C5.32617 10.3606 5.32717 10.2998 5.3439 10.2424L5.90389 8.32712C5.96691 8.11249 6.08291 7.91717 6.24122 7.75913L12.2498 1.7499Z"
      stroke="#4A5565"
      stroke-width="1.33331"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
